import {interfaceTranslations} from "./interface.js";
import {countryTranslations} from "./countries.js";

const allTranslations = { ...countryTranslations, ...interfaceTranslations };

export default allTranslations;
